module.exports = __webpack_public_path__ + "static/desktop/img/paperback-en.0cf1653d.png";